/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Sub_Categories_DetailInputs */

const en_common_header_explore_sub_categories_detail = /** @type {(inputs: Common_Header_Explore_Sub_Categories_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find by tool type`)
};

const zh_common_header_explore_sub_categories_detail = /** @type {(inputs: Common_Header_Explore_Sub_Categories_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按工具类型查找`)
};

/**
* | output |
* | --- |
* | "Find by tool type" |
*
* @param {Common_Header_Explore_Sub_Categories_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_sub_categories_detail = /** @type {((inputs?: Common_Header_Explore_Sub_Categories_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Sub_Categories_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_sub_categories_detail(inputs)
	return zh_common_header_explore_sub_categories_detail(inputs)
});
export { common_header_explore_sub_categories_detail as "common.header.explore.sub_categories.detail" }